import { Injectable } from '@angular/core';
import {MdDialog} from '@angular/material';
import {ConfirmationDialogComponent} from '../../components/confirmation-dialog/confirmation-dialog.component';


@Injectable()
export class ConfirmationDialogService {

  constructor(public dialog: MdDialog) { }

  public openDialog(messageSent: boolean) {
    this.dialog.open(ConfirmationDialogComponent, {
      data: messageSent
    });
  }

}






// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/confirmation-dialog/confirmation-dialog.service.ts